'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002459 from "./presto.-Two-Factor-Auth-View$$anon$59.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002461 from "./presto.-Two-Factor-Auth-View$$anon$61.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002463 from "./presto.-Two-Factor-Auth-View$$anon$63.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002465 from "./presto.-Two-Factor-Auth-View$$anon$65.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$58() {
  this.bG2 = null;
  this.bFU = null;
  this.bFV = false;
  this.bG3 = null;
  this.bG4 = false;
  this.bG7 = null;
  this.bG0 = null;
  this.bG1 = false;
  this.bFW = null;
  this.bFX = false;
  this.bFY = null;
  this.bFZ = false;
  this.bG5 = false;
  this.bG6 = false;
  this.bG2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bG7 = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$58 as $c_Lpresto_TwoFactorAuthView$$anon$58 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$58;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$58() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$58 as $h_Lpresto_TwoFactorAuthView$$anon$58 };
$h_Lpresto_TwoFactorAuthView$$anon$58.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bG2;
});
$p.M = (function() {
  if ((!this.bFV)) {
    this.bFU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bFV = true;
  }
  return this.bFU;
});
$p.O = (function() {
  if ((!this.bG4)) {
    this.bG3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bG4 = true;
  }
  return this.bG3;
});
$p.D = (function() {
  return this.bG7;
});
$p.t = (function() {
  if ((!this.bG1)) {
    this.bG0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bG1 = true;
  }
  return this.bG0;
});
$p.N = (function() {
  if ((!this.bFX)) {
    this.bFW = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002459.$c_Lpresto_TwoFactorAuthView$$anon$59(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002461.$c_Lpresto_TwoFactorAuthView$$anon$61())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002463.$c_Lpresto_TwoFactorAuthView$$anon$63())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bFX = true;
  }
  return this.bFW;
});
$p.Q = (function() {
  if ((!this.bFZ)) {
    this.bFY = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002465.$c_Lpresto_TwoFactorAuthView$$anon$65();
    this.bFZ = true;
  }
  return this.bFY;
});
$p.v = (function() {
  if ((!this.bG6)) {
    this.bG5 = false;
    this.bG6 = true;
  }
  return this.bG5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee681) => ((p) => \u03b4scrutinee681.zl(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$58, "presto.TwoFactorAuthView$$anon$58", ({
  T4: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$58 as $d_Lpresto_TwoFactorAuthView$$anon$58 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$58.js.map
